import { animate, onScroll } from "animejs";

const revealSelector =
    ".feature-posts-item, .review-post, .about-me__content > *, .about-me__image";

function animateOnScroll(element, target, properties, thresholds = {}) {
    animate(element, {
        ...properties,
        ease: "linear",
        autoplay: onScroll({
            container: document.body,
            target,
            axis: "y",
            sync: true,
            ...thresholds,
        }),
    });
}

function animateParallax() {
    const pageHeroSelectors = [
        [".hero__background", ".hero"],
        [".custom-post-feature-hero__image", ".custom-post-feature-hero"],
        [".custom-post-review-hero__image", ".custom-post-review-hero"],
    ];

    pageHeroSelectors.forEach(([imageSelector, sectionSelector]) => {
        document.querySelectorAll(imageSelector).forEach((image) => {
            const section = image.closest(sectionSelector);

            if (section) {
                animateOnScroll(
                    image,
                    section,
                    { y: ["0%", "50%"] },
                    { enter: "start start" },
                );
            }
        });
    });

    document
        .querySelectorAll(".feature-posts__background")
        .forEach((background) => {
            const section = background.closest(".feature-posts");

            if (section) {
                animateOnScroll(background, section, { y: ["-50%", "0%"] });
            }
        });

    document.querySelectorAll(".feature-posts-item__image").forEach((image) => {
        const card = image.closest(".feature-posts-item__inner");

        if (card) {
            animateOnScroll(image, card, { y: ["-3%", "3%"] });
        }
    });
}

function getRevealDelay(element) {
    const siblingIndex = Array.prototype.indexOf.call(
        element.parentElement.children,
        element,
    );

    if (element.matches(".review-post")) {
        if (siblingIndex % 3 === 1) {
            return 100;
        }

        if (siblingIndex % 3 === 2) {
            return 200;
        }
    }

    if (
        (element.matches(".feature-posts-item") ||
            element.parentElement.matches(".about-me__content")) &&
        siblingIndex % 2 === 1
    ) {
        return 120;
    }

    return 0;
}

function animateOnEnter() {
    if (!("IntersectionObserver" in window)) {
        return;
    }

    const elements = document.querySelectorAll(revealSelector);

    if (!elements.length) {
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.unobserve(entry.target);
                animate(entry.target, {
                    opacity: [0, 1],
                    y: [20, 0],
                    duration: 1000,
                    delay: getRevealDelay(entry.target),
                    ease: "out(3)",
                });
            });
        },
        {
            threshold: 0.15,
            rootMargin: "0px 0px -32px 0px",
        },
    );

    elements.forEach((element) => {
        element.style.opacity = "0";
        element.style.transform = "translateY(20px)";
        observer.observe(element);
    });
}

export default function initAnimations() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
    }

    animateParallax();
    animateOnEnter();
}
